import { useEffect, useState } from 'react';
import { Breadcrumb, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { IFormType } from '../../commons/interfaces/form-type.interface';
import CustomTable from '../../components/CustomTable';
import Paper from '../../components/Paper';
import FormService from '../../services/form.service';
import tableColumnMetadata from './table.metadata';

const formService = new FormService();

// TODO: Ver que sucede si se elimina un administrador (ticket)
const FormPage = () => {
  const navigate = useNavigate();
  const [formTypes, setFormTypes] = useState<IFormType[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFormTypes = async () => {
      setLoading(true);

      const response = await formService.listFormTypes();

      setFormTypes(response.data);
      setLoading(false);
    };

    fetchFormTypes();
  }, []);

  const handleClickRow = (formType: IFormType) => {
    navigate(`./${formType.uniqueCode}/responses`);
  };

  return (
    <Container id="formpage" fluid>
      <Breadcrumb>
        <Breadcrumb.Item active>Formularios</Breadcrumb.Item>
      </Breadcrumb>
      <Paper>
        <Row className="justify-content-between mb-a">
          <Col className="d-flex m-auto">
            <span>Listado de formularios</span>
          </Col>
          <Row>
            <Col>
              <CustomTable<IFormType>
                data={formTypes}
                loading={loading}
                columnsMetadata={tableColumnMetadata}
                onClickRow={handleClickRow}
              />
            </Col>
          </Row>
        </Row>
      </Paper>
    </Container>
  );
};

export default FormPage;
